/**
 * @file StatisticConst.js
 * @desc 统计日志埋点静态文件
 * @author ~~
 * @data 2020/4/22
 */
import statisticAction from '@/common/utils/statisticAction';
const statisticConst = {};
// const sendBaiduStatistics = statisticAction.sendBaiduStatistics;
const sendStatisticalInfo = statisticAction.submitStatisticalInfo;
const baiduKey = 'cjh.dachecoupon';


// 首页展现来源
statisticConst.homeFrom = param => {
    sendStatisticalInfo(baiduKey + '.from', param);
};

// 输入手机号统计
statisticConst.input = () => {
    sendStatisticalInfo(baiduKey + '.input');
};

// 立即领取统计
statisticConst.getCoupon = () => {
    sendStatisticalInfo(baiduKey + '.getCoupon');
};

// 立即使用统计
statisticConst.goDache = () => {
    sendStatisticalInfo(baiduKey + 'goDache');
};

export default statisticConst;
